import React, { useState, useEffect } from "react";

import { Row, Col, Input, Button, Alert, Container, Label } from "reactstrap";
import { apiReq } from "../../utils/utils";
import * as url from "../../utils/urls";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import QRCode from "react-qr-code";

import { Link } from "react-router-dom";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-light.png";
import EEAA_LOGO from "../../assets/images/eeaa.png";
import Swal from "sweetalert2";

const LoginSSO = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const history = useHistory();
  // dispatch
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setIsLoading(true);
    apiReq(
      url.SEND_EMAIL_MAGIC_LINK,
      {
        email: data.email,
      },
      "post",
      {}
    )
      .then((res) => {
        console.log(res);
        if (res.success) {
          setIsSuccess(true);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: "Password reset link sent to your email",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.apiStatus.statusMessage);
      });
    console.log("Login values", data);
  };

  useEffect(() => {
    document.body.classList.add("auth-body-bg");

    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, []);
  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={8}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={5}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="">
                              <img
                                src={logodark}
                                alt=""
                                height="50"
                                className="auth-logo logo-dark mx-auto"
                              />
                              <img
                                src={logolight}
                                alt=""
                                height="50"
                                className="auth-logo logo-light mx-auto"
                              />
                            </Link>
                          </div>

                          <h4 className="font-size-18 mt-4">
                            Log In with Single Sign-On (SSO)
                          </h4>
                          <p className="text-muted">
                            Enter your email address and we'll send you a link
                          </p>
                        </div>

                        <div className="p-2 mt-3">
                          <form
                            className="form-horizontal"
                            onSubmit={handleSubmit(onSubmit)}
                          >
                            {errors.email && (
                              <div
                                className="alert alert-danger alert-dismissible mb-2"
                                role="alert"
                              >
                                {errors.email.message}
                              </div>
                            )}
                            <div className="mb-4 form-group">
                              <label>Email</label>
                              <input
                                type="email"
                                placeholder="Enter your work email"
                                className="form-control form-control-lg input-lg"
                                {...register("email", {
                                  required: "Email address is required.",
                                  pattern: {
                                    value:
                                      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "invalid email address",
                                  },
                                })}
                              />
                            </div>

                            <div className="mt-4 text-center">
                              {isLoading ? (
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="button"
                                  block
                                  style={{ width: "100%" }}
                                >
                                  Loading...
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  className="w-md waves-effect waves-light"
                                  type="submit"
                                  block
                                  style={{ width: "100%" }}
                                >
                                  Send
                                </Button>
                              )}
                            </div>
                            <div className="d-flex justify-content-start mt-3">
                              <Link to="/login" className="text-link">
                                <strong>Return to log in</strong>
                              </Link>
                            </div>

                            {/* <div className="mt-4 text-center">
                              <Link
                                to="/forgot-password"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock me-1"></i> Forgot
                                your password?
                              </Link>
                            </div> */}
                          </form>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={4}>
              <div className="authentication-bg">
                <div
                  className="login_options d-flex align-items-center"
                  style={{ height: "100%" }}
                >
                  <div className="options_inner">
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center mb-0">Recognized as</p>
                    <p className="text-center">
                      EEAA Best Innovation in Event Tech Winner
                    </p>
                    <div className="login_option_logo_wrapper">
                      <div className="login_option_logo d-flex justify-content-center align-items-center">
                        <img src={EEAA_LOGO} alt={"EEAA_LOGO"} width="200" />
                      </div>
                      <div className="sap_line"></div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_lg">
                        <i className="ri-star-fill"></i>
                      </span>
                      <span className="star star_sm">
                        <i className="ri-star-fill"></i>
                      </span>
                    </div>
                    <p className="text-center" style={{ fontSize: 18 }}>
                      Recognized by customers across the world as a leader in
                      tech event, online & mobile solutions.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LoginSSO;
